import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { faXTwitter } from 'components/shared/XTwitterIcon';
import Link from 'next/link';
import {
  StyledCardLink,
  StyledContent,
  StyledDesc,
  StyledImg,
  StyledName,
  StyledSocial
} from './TeamCard.styled';

export type TeamCardProps = {
  url?: string;
  name: string;
  img: string;
  desc: string;
  linkedin?: string;
  twitter?: string;
};

const TeamCard: React.FC<TeamCardProps> = ({
  url,
  name,
  img,
  desc,
  linkedin,
  twitter
}) => {
  return (
    <Link href={url || '#'} passHref>
      <StyledCardLink
        onClick={(e) => {
          if (!url) {
            e.preventDefault();
          }
        }}
      >
        <StyledImg>
          <img src={img} alt={name} />
        </StyledImg>
        <StyledContent>
          <StyledName>{name}</StyledName>
          <StyledDesc>{desc}</StyledDesc>
          <StyledSocial>
            {twitter && (
              <ButtonLink
                variant="tertiary"
                sizes="sm"
                isIcon
                href={twitter}
                target="_blank"
                rel="noreferrer"
                title="Twitter"
                onClick={(e) => e.stopPropagation()}
              >
                <FontAwesomeIcon aria-hidden="true" icon={faXTwitter} />
              </ButtonLink>
            )}
            {linkedin && (
              <ButtonLink
                variant="tertiary"
                sizes="sm"
                isIcon
                href={linkedin}
                target="_blank"
                rel="noreferrer"
                title="LinkedIn"
                onClick={(e) => e.stopPropagation()}
              >
                <FontAwesomeIcon aria-hidden="true" icon={faLinkedin} />
              </ButtonLink>
            )}
          </StyledSocial>
        </StyledContent>
      </StyledCardLink>
    </Link>
  );
};

export default TeamCard;
